<template>
  <div class="container">
    <div class="mask"></div>
    <LayoutsHeader
      :showSearchInput="showSearchInput"
      :isShowSubmit="isShowSubmit"
      :isShowHistory="isShowHistory"
      @showSearch="showSearch"
      @hideSearch="hideSearch"
      @showSubmit="showSubmit"
      @showHistory="showHistory"
      @hideHistory="hideHistory" />
    <div :class="['main', showSearchInput ? 'noscroll' : '']">
      <div class="slot-content">
        <slot />
      </div>

      <LayoutsFooter :isSelectCountry="isSelectCountry" />
      <LayoutsSideToolbar
        :isShowChatIcon="isShowChatIcon"
        :backTopFlag="backTopFlag"
        @backup="backup" />
      <div
        class="history_dialog"
        v-if="showSearchInput"
        @click="hideSearch"></div>
    </div>
  </div>
</template>
<script setup lang="ts" name="">
const backTopFlag = ref(false);
const route = useRoute();

const isShowChatIcon = computed(() => route.meta?.isShowChatIcon);
const isSelectCountry = computed(() => route.meta?.isSelectCountry);

function backup() {
  if (process.client) {
    document.getElementsByClassName('main')[0].scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
onMounted(() => {
  if (process.client) {
    const ele = document.getElementsByClassName('main')[0] as HTMLElement;
    ele.addEventListener('scroll', function () {
      backTopFlag.value = ele.scrollTop > 750;
    });
  }
});

const showSearchInput = ref(false);
const isShowSubmit = ref(false);
const isShowHistory = ref(false);
const showSearch = () => {
  showSearchInput.value = true;
};
const hideSearch = () => {
  showSearchInput.value = false;
  hideSubmit();
  hideHistory();
};

const showSubmit = () => {
  isShowSubmit.value = true;
};
const hideSubmit = () => {
  isShowSubmit.value = false;
};

const showHistory = () => {
  isShowHistory.value = true;
};

const hideHistory = () => {
  isShowHistory.value = false;
};
</script>

<style scoped lang="scss">
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 1200px;
  width: 100%;
  // cursor: pointer;
  .main {
    height: calc(100vh - 60px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    user-select: none; // 禁止选中复制
    // width: 100vw;
    padding-top: 60px;
    &.noscroll {
      overflow: hidden !important;
    }
    .slot-content {
      flex-grow: 1;
    }
    .history_dialog {
      background-color: rgba(0, 0, 0, 0.15);
      backdrop-filter: blur(10px);
      position: fixed;
      top: 60px;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 599;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    z-index: 110;
    display: none;
  }
}
</style>
